var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.144 19.6165L10.2704 24.4901C9.48938 25.2711 8.85622 25.0089 8.85622 23.9043V16.118L15.144 9.83013V19.6165Z",
    fill: "#C1C1C1",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27783 2C6.27783 0.895428 7.17326 0 8.27783 0H15.1339V9.83028H6.27783V2Z",
    fill: "#DB4437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.6604C24 18.765 23.1046 19.6604 22 19.6604H15.1439V9.83012H24V17.6604Z",
    fill: "#DB4437"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2876 9.83008H15.134L8.84618 16.1179H1.99977C0.895204 16.1179 0.632937 15.4847 1.41399 14.7037L6.2876 9.83008Z",
    fill: "#0072CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2001_1455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1168 14.7042C18.3358 15.4852 16.8072 16.1184 15.7026 16.1184H8.85623L15.1441 9.83058H23.9905L19.1168 14.7042Z",
    fill: "#0072CE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2001_1455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84619 8.33179C8.84619 7.22722 9.47936 5.69862 10.2604 4.91757L15.134 0.0439617V9.83029L8.84619 16.1181V8.33179Z",
    fill: "#C1C1C1",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2001_1455",
    x: 2.85645,
    y: 3.83057,
    width: 27.1338,
    height: 18.2878,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2001_1455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2001_1455",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2001_1455",
    x: 2.84619,
    y: -5.95605,
    width: 18.2876,
    height: 28.0742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2001_1455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2001_1455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.5531f15dc2ab41d4f38326d1eedbc984.svg";
export { ForwardRef as ReactComponent };